<template>
  <div>
    <div class="searchbar">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="手机号码">
          <el-select filterable v-model="filters.toolbarChecked" clearable>
            <el-option
                v-for="item in selectUser"
                :key="item.userId"
                :label="item.cellphone"
                :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="findPage()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格栏-->
    <div class="table-wrap">
      <el-table :data="tableData.data" stripe highlight-current-row max-height="460" size="small"
                style="width:100%;">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column v-for="column in columns" header-align="center" align="center"
                         :prop="column.prop" :label="column.label" :width="column.width"
                         :min-width="column.minWidth"
                         show-overflow-tooltip
                         :fixed="column.fixed" :key="column.prop" :type="column.type">
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding:10px;">
        <el-pagination layout="sizes,total, prev, pager, next, jumper" @current-change="refreshPageRequest"
                       @size-change="handleSizeChange"
                       :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                       :page-sizes="pageRequest.pageSizes"
                       show-overflow-tooltip
                       :total="tableData.totalSize" style="float:right;">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "integralItem",
  data() {
    return {

      selectUser: [],
      pageRequest: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 50, 100]
      },
      tableData: {
        'totalSize': 0,
        'data': []
      },
      dialogVisible: false,
      filters: {
        toolbarChecked: null,
      },
      columns: [
        {prop: 'cellphone', label: '手机号码', minWidth: 80},
        {prop: 'changeIntegral', label: '积分变化', minWidth: 40},
        {prop: 'typeName', label: '类型', minWidth: 80},
        {prop: 'note', label: '备注', minWidth: 80},
        {prop: 'createdBy', label: '创建人', minWidth: 80},
        {prop: 'createdAt', label: '创建时间', minWidth: 80},
      ],
    }
  },
  methods: {
    // 分页查询
    findPage: function () {
      if (this.filters.toolbarChecked === null){
        this.$message.error("请选择会员手机号");
        return
      }

      let requestData = {
        userId: this.filters.toolbarChecked,
        pageNo: this.pageRequest.pageNum,
        pageSize: this.pageRequest.pageSize,
      };
      this.$api.integralItem.selectIntegralItem(requestData).then((res) => {
        this.tableData.totalSize = res.total;
        this.tableData.data = res.list;
      });
    },
    // 换页刷新
    refreshPageRequest: function (pageNum) {
      this.pageRequest.pageNum = pageNum;
      this.findPage()
    },
    handleSizeChange: function (pageSize) {
      this.pageRequest.pageSize = pageSize;
      this.pageRequest.pageNum = 1;
      this.findPage()
    },
  },
  components: {},
  mounted() {
  },
  created() {
    let requestData = {
      pageNo: 0,
      pageSize: 0,
    };
    this.$api.user.selectUser(requestData).then((res) => {
      this.selectUser = res.list
    });

    const routerParams = JSON.parse(decodeURIComponent(this.$route.query.param));
    this.filters.toolbarChecked = routerParams.userId;
    this.findPage();
  }
}
</script>

<style scoped>
</style>